const formatPrice = (priceInCents: number | null) => {
  return priceInCents ? priceInCents.toString().slice(0, -2) : ''
}

export default formatPrice
